<template lang="pug">
  div(class="documents-api-action-results")
    div(class="documents-api-action-results__image")
      v-img(
        :src="image"
        max-width="80"
      )
    div(
      v-if="failedDocuments.length"
      class="documents-api-action-results__failed-documents"
    )
      div(
        v-for="(document, idx) in failedDocuments"
        :key="idx"
        class="documents-api-action-results__failed-item"
      )
        div(class="d-flex align-center justify-space-between")
          div(class="text-left")
            div(class="text-14px light") {{ document.title }}
            div(v-if="document.reason")
              div(class="text-12px dark pr-1") {{ $t('Error') }}:
              div(
                class="documents-api-action-results__failed-item-reason documents-api-action-results__failed-item-reason--error"
              ) {{ document.reason }}
          div
            div(class="documents-api-action-results__failed-item-icon")
              e-svg-icon close-circle-red
</template>

<script>
export default {
  name: 'BlockDocumentsApiActionResults',
  props: {
    image: {
      type: String,
      default: () => require('~/assets/images/party-popper.png')
    },
    failedDocuments: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped lang="scss">
.documents-api-action-results {
  &__image {
    display: flex;
    justify-content: center;
    padding-bottom: 16px;
  }
  &__failed-documents {
    margin-top: 16px;

    border-radius: 12px;
    background: $background-secondary-alternative;
  }
  &__failed-item {
    padding: 12px;

    &-reason {
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      padding-right: 8px;

      &--error {
        color: $danger;
      }
    }
  }
}
</style>
